import type { SRT_Row, SRT_RowData } from '@/shared/components/master-table'
import type { TableData } from '../model/types'

import { Share2Icon } from 'lucide-react'
import { useFormContext } from 'react-hook-form'

import { BasicNumberEditorField, BasicTextField } from '@/entities/column'

import { cn } from '@/shared/lib/utils'

export const SkuCell = ({ value }: { value: string }) => {
	const { watch } = useFormContext()
	const anchorProduct = watch('anchor_product')
	const isAnchorSku = value === anchorProduct?.sku

	return (
		<div className='flex items-center gap-2'>
			{isAnchorSku && <Share2Icon className='size-4' />}
			<BasicTextField value={value} />
		</div>
	)
}
export const SourceFamilyIdCell = () => {
	const { watch } = useFormContext()
	const sourceFamilyId = watch('source_family_id') as string

	return <BasicTextField value={sourceFamilyId || '-'} />
}
export const MulIdxCell = ({ row }: { row: SRT_Row<SRT_RowData> }) => {
	const { formState, watch, setValue, clearErrors } = useFormContext()
	const anchorProduct = watch('anchor_product')
	const value = watch(`anchors.${row.index}.mul`) as number
	const handleChange = (value: number) => {
		setValue(`anchors.${row.index}.mul`, value, {
			shouldValidate: true,
		})
		clearErrors([`anchors.${row.index}`])
	}
	const isAnchorSku = row.original.sku === anchorProduct?.sku
	const hasError = !!(
		formState.errors?.anchors as unknown as TableData['anchors']
	)?.[row.index]

	return (
		<BasicNumberEditorField
			className={cn(
				'rounded-lg border bg-input/20 px-3 py-1 dark:bg-input/30',
				{
					'border-destructive ring-[3px] ring-destructive/20 dark:ring-destructive/40':
						hasError,
					'cursor-none-allowed pointer-events-none opacity-70': isAnchorSku,
				}
			)}
			value={value}
			onChange={handleChange}
			originalValue={null}
			isDirty={!!value}
		/>
	)
}
export const AddIdxCell = ({ row }: { row: SRT_Row<SRT_RowData> }) => {
	const { formState, watch, setValue, clearErrors } = useFormContext()
	const anchorProduct = watch('anchor_product')
	const value = watch(`anchors.${row.index}.add`) as number
	const isAnchorSku = row.original.sku === anchorProduct?.sku
	const handleChange = (value: number) => {
		setValue(`anchors.${row.index}.add`, value, {
			shouldValidate: true,
		})
		clearErrors([`anchors.${row.index}`])
	}
	const hasError = !!(
		formState.errors?.anchors as unknown as TableData['anchors']
	)?.[row.index]

	return (
		<BasicNumberEditorField
			className={cn(
				'rounded-lg border bg-input/20 px-3 py-1 dark:bg-input/30',
				{
					'border-destructive ring-[3px] ring-destructive/20 dark:ring-destructive/40':
						hasError,
					'cursor-none-allowed pointer-events-none opacity-70': isAnchorSku,
				}
			)}
			value={value}
			onChange={handleChange}
			originalValue={null}
			isDirty={!!value}
		/>
	)
}
